
import { cloneDeep } from 'lodash';
import { ContextItem } from 'twyne-new.ui';

import { useCustomKeyframe } from '@/components/builder/utils/tailwindConfig/hooks';

import { ContextMenuPopover } from '../components/tailwindSandbox';

import AddPopover from './AddPopover';
import { useAnimation } from './context';

function ContextMenu() {
  const { animation, animation: { rightClick: { mouse = {}, selected = {}, custom } }, setAnimation } = useAnimation()
  const { value: keyframes, setValue: setKeyframes } = useCustomKeyframe()

  const handleDelete = () => {
    const newKeyframes = cloneDeep(keyframes)
    delete newKeyframes[selected.name]
    setKeyframes(newKeyframes)
  }

  const handleEdit = newKeyframe => {
    const newKeyframes = cloneDeep(keyframes)
    newKeyframes[selected.name] = newKeyframe.keyframe
    setKeyframes(newKeyframes)
  }

  const handleDuplicate = () => {
    const newName = `${selected.name}-copy`
    setKeyframes({ ...keyframes, [newName]: selected.keyframe })
    setAnimation({ ...animation, duplicated: { name: newName, keyframe: selected.keyframe } })
  }

  const options = [
    {
      label: 'Edit',
      component: <AddPopover
        keyframe={selected}
        editing
        trigger={<button disabled={!custom}><ContextItem disabled={!custom}>Edit</ContextItem></button>}
        onSubmit={handleEdit}
      />,
    },
    {
      label: 'Delete',
      onClick: handleDelete,
      disabled: !custom,
    },
    {
      label: 'Duplicate',
      onClick: handleDuplicate,
      disabled: false,
    },
  ]

  return <ContextMenuPopover
    selected={selected?.name}
    options={options}
    mouse={{ left: mouse.x + 15, top: mouse.y + 35 }}
  />
}

export default ContextMenu
